import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-content: center;
	flex-direction: column;
	gap: 2rem;
`;

export const ChartContainer = styled.div`
	margin: auto;
	width: ${(props) => props.width};
`;
